// Disable bs5 jquery overwrite
document.body.setAttribute('data-bs-no-jquery', '')
